/**
 * RiskStatCard - Statistics card for Gaps & Risks page header
 */
import React from 'react';

export default function RiskStatCard({ icon: Icon, label, value, description, bgColor = 'bg-red-500/20' }) {
  return (
    <div className={`p-4 rounded-lg ${bgColor} border border-white/20`} data-testid="risk-stat-card">
      <div className="flex items-center gap-2 mb-2">
        <Icon className="h-4 w-4 text-white" />
        <p className="text-xs text-white/80">{label}</p>
      </div>
      <p className="text-3xl font-bold text-white">{value}</p>
      {description && (
        <p className="text-xs text-white/70 mt-1">{description}</p>
      )}
    </div>
  );
}
